module.exports = __webpack_public_path__ + "img/jumbotron-pic-2@2x.5e6ec74b.png";